import React, { useEffect } from "react";
import Styles from "./Settings.module.scss";
import { useAppDispatch } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { getProfileInfo } from "../../../../redux/profile/settings/getProfileInfo/selectors";
import { fetchProfileInfo } from "../../../../redux/profile/settings/getProfileInfo/asyncActions";
import {Button, Modal, PassChangeModal, Title} from "../../../../components";
import { ChangeUserName } from "../../Forms/ChangeUserName/ChangeUser";
import {
  fetchEditEmail,
  fetchEditName,
  fetchEditPassword,
  fetchEditPhone,
} from "../../../../redux/profile/settings/changeDataProfile/asyncActions";
import { fetchDeleteUser } from "../../../../redux/profile/settings/deleteUser/asyncActions";
import { ChangeEmail } from "../../Forms/EmailForm/ChangeEmail";
import { ChangePhone } from "../../Forms/PhoneForm/ChangePhone";
import {
  removeTokenToStorage,
  setSelectedSubscrToStorage
} from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { cartSelector } from "../../../../redux/cart/selectors";
import { ChangePassword } from "../../Forms/ChangePassword/ChangePassword";
import { PhoneCodeForm } from "../../Forms/PhoneForm/PhoneCodeForm";
import { fetchSendPhoneCode } from "../../../../redux/profile/settings/changeDataProfile/asyncActions";
import {setSelectedSubscr} from "../../../../redux/subscriptions/slice";
import {setSelectedHalls} from "../../../../redux/halls/slice";
import {setCartItems} from "../../../../redux/cart/slice";
import {setSelectedHallsToStorage} from "../../../../utils/storage/halls";
import {clearAuthData} from "../../../../redux/auth/slice";

import profileIcon from "../../../../assets/icons/profile.svg";
import phoneIcon from "../../../../assets/icons/phone.png";
import emailIcon from "../../../../assets/icons/email.png";
import passwordIcon from "../../../../assets/icons/changePasswordIcon.svg";
import exitIcon from "../../../../assets/icons/exitIcon.svg";
import trashIcon from "../../../../assets/icons/trashRed.svg";
import arrowRightIcon from "../../../../assets/icons/arrowMenuRight.svg";
import { SEND_CODE_FAILED_MESSAGE } from "../../../../helpers/sendCodeError";
const Settings: React.FC = () => {
  const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
  const [type, setType] = React.useState<string>("");
  const [title, settitle] = React.useState<string>("");
  const [subTitle, setsubTitle] = React.useState<string>("");
  const [placeHolder, setplaceHolder] = React.useState<string>("");
  const [phoneForVerification, setPhoneForVerification] = React.useState<string>("");
  const [showPhoneCodeForm, setShowPhoneCodeForm] = React.useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { profileInfo } = useSelector(getProfileInfo);

  const HandleClickChangeName = () => {
    settitle("Сменить имя");
    setType("changeName");
    setplaceHolder("Введите имя");
    setIsOpenModal(true);
  };

  const HandleClickChangeEmail = () => {
    settitle("Сменить почту");
    setType("changeEmail");
    setplaceHolder("Введите почту");
    setIsOpenModal(true);
  };
  const HandleClickChangePhone = () => {
    settitle("Сменить телефон");
    setType("changePhone");
    setplaceHolder("+7 --- --- -- --");
    setShowPhoneCodeForm(false);
    setPhoneForVerification("");
    setIsOpenModal(true);
  };
  const handleChangePass = () => {
    setType("changePassword");
    settitle("Смена пароля");
    setIsOpenModal(true);
    setplaceHolder("Пароль");
  };
  const handleEndEditNameClose = async () => {
    await dispatch(fetchProfileInfo());
    setIsOpenModal(false);
  };

  const HandleClickExit = () => {
    settitle("Выход");
    setType("exitClick");
    setsubTitle("Выйти из учетной записи?");
    setIsOpenModal(true);
  };

  const HandleClickDeleteAccount = () => {
    settitle("Удаление аккаунта");
    setType("deleteAccount");
    setsubTitle("Вы уверены, что хотите удалить аккаунт? Это действие необратимо.");
    setIsOpenModal(true);
  };

  const handleDeleteAccount = async () => {
    try {
      const result = await dispatch(fetchDeleteUser());
      
      if (result.type.includes("fulfilled")) {
        removeTokenToStorage();
        handleDeleteAllCartItems();
        dispatch(clearAuthData());
        window.location.href = "/";
      } else {
      alert("Ошибка при удалении аккаунта. Попробуйте позже.");
    }
  } catch (error) {
    alert("Ошибка при удалении аккаунта. Попробуйте позже.");
  }
  };

  const handleCloseModalNoConfirm = () => {
    dispatch(fetchProfileInfo());
    setIsOpenModal(false);
  };

  const handleDeleteAllCartItems = () => {
    const emptyCart = { subscriptions: {}, seats: {} };
    dispatch(setCartItems(emptyCart));
    dispatch(setSelectedSubscr(emptyCart.subscriptions));
    setSelectedSubscrToStorage(emptyCart.subscriptions);
    dispatch(setSelectedHalls(emptyCart.seats));
    setSelectedHallsToStorage(emptyCart.seats);
  };

  const handleCloseModalConfirm = () => {
    removeTokenToStorage();
    handleDeleteAllCartItems();
    dispatch(clearAuthData());
    window.location.href = "/";
  };

  useEffect(() => {
    dispatch(fetchProfileInfo());
  }, []);

  return (
    <div className={Styles.container}>
      <h1 className={Styles.title}>Настройки</h1>
      <div className={Styles.wrapper}>
        <div onClick={HandleClickChangeName} className={Styles.wrapper_item}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={profileIcon} alt="Имя" />
            </div>
            <div className={Styles.item_info}>
              <div className={Styles.item_label}>Имя</div>
              <div className={Styles.item_value}>{profileInfo?.[0]?.name || "Не указано"}</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>

        <div onClick={HandleClickChangePhone} className={Styles.wrapper_item}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={phoneIcon} alt="Телефон" />
            </div>
            <div className={Styles.item_info}>
              <div className={Styles.item_label}>Телефон</div>
              <div className={Styles.item_value}>{profileInfo?.[0]?.phone || "Не указано"}</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>

        <div onClick={HandleClickChangeEmail} className={Styles.wrapper_item}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={emailIcon} alt="Email" />
            </div>
            <div className={Styles.item_info}>
              <div className={Styles.item_label}>E-mail</div>
              <div className={Styles.item_value}>{profileInfo?.[0]?.email || "Не указано"}</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>

        <div onClick={handleChangePass} className={Styles.wrapper_item}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={passwordIcon} alt="Пароль" />
            </div>
            <div className={Styles.item_info}>
              <div className={Styles.item_label}>Пароль</div>
              <div className={Styles.item_value}>••••••••</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>

        <div className={Styles.divider}></div>

        <div onClick={HandleClickExit} className={`${Styles.wrapper_item} ${Styles.wrapper_item_action}`}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={exitIcon} alt="Выход" />
            </div>
            <div className={Styles.item_info}>
              <div className={Styles.item_label}>Выход</div>
              <div className={Styles.item_value}>Выйти из учетной записи</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>

        <div onClick={HandleClickDeleteAccount} className={`${Styles.wrapper_item} ${Styles.wrapper_item_delete}`}>
          <div className={Styles.item_content}>
            <div className={Styles.item_icon}>
              <img src={trashIcon} alt="Удалить" />
            </div>
            <div className={Styles.item_info}>
              <div className={`${Styles.item_label} ${Styles.item_label_delete}`}>Удалить аккаунт</div>
              <div className={`${Styles.item_value} ${Styles.item_value_delete}`}>Это действие необратимо</div>
            </div>
          </div>
          <img src={arrowRightIcon} alt="" className={Styles.item_arrow} />
        </div>
      </div>
      {isOpenModal ? (
        <Modal
          title={title}
          isOpen={isOpenModal}
          setIsOpen={setIsOpenModal}
          closeFunc={handleEndEditNameClose}
          subTitle={subTitle}
        >
          {type === "exitClick" && (
            <div className={Styles.buttons}>
              <Button onClickFunc={handleCloseModalConfirm}>Да</Button>
              <Button onClickFunc={handleCloseModalNoConfirm}>Нет</Button>
            </div>
          )}
          {type === "deleteAccount" && (
            <div className={Styles.buttons}>
              <Button onClickFunc={handleDeleteAccount}>Да, удалить</Button>
              <Button onClickFunc={handleCloseModalNoConfirm}>Отмена</Button>
            </div>
          )}
          {type === "changeName" && (
            <ChangeUserName
              close={async (values) => {
                const result = await dispatch(fetchEditName({ name: values }));
                if (result.payload === 200) {
                  await dispatch(fetchProfileInfo());
                  setIsOpenModal(false);
                }
              }}
              type={type}
              placeholder={placeHolder}
            />
          )}
          {type === "changePassword" && (
            <ChangePassword
              close={async (password: string) => {
                const result = await dispatch(
                  fetchEditPassword({ password })
                );
                if (result.payload === 200) {
                  await dispatch(fetchProfileInfo());
                  setIsOpenModal(false);
                }
              }}
              type={type}
              placeholder={placeHolder}
            />
          )}
          {type === "changeEmail" && (
            <ChangeEmail
              close={async (email) => {
                const result = await dispatch(fetchEditEmail({ email: email }));
                if (result.payload === 200) {
                  await dispatch(fetchProfileInfo());
                  setIsOpenModal(false);
                }
              }}
              type={type}
              placeholder={placeHolder}
            />
          )}
          {type === "changePhone" && !showPhoneCodeForm && (
            <ChangePhone
              close={async (value) => {
                try {
                  const result = await dispatch(fetchSendPhoneCode({ phone: value }));
                  
                  if (result.payload === 200) {
                    setPhoneForVerification(value);
                    setShowPhoneCodeForm(true);
                  } else {
                    alert(SEND_CODE_FAILED_MESSAGE);
                  }
                } catch (error) {
                  alert(SEND_CODE_FAILED_MESSAGE);
                }
              }}
              type={type}
              placeholder={placeHolder}
            />
          )}
          {type === "changePhone" && showPhoneCodeForm && (
            <PhoneCodeForm
              phone={phoneForVerification}
              onSuccess={async () => {
                await dispatch(fetchProfileInfo());
                setIsOpenModal(false);
                setShowPhoneCodeForm(false);
                setPhoneForVerification("");
              }}
              onCancel={() => {
                setShowPhoneCodeForm(false);
                setPhoneForVerification("");
              }}
            />
          )}
        </Modal>
      ) : null}
    </div>
  );
};

export default Settings;
